const Error = (props: any) => {
  const { name, errors } = props

  return <div className="validation-error">{errors[name] ? errors[name][0] : ''}</div>
}

export default Error;